import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { requestClientes, requestClientesSearch } from "../../actions/cliente";
import { Grid, TextField, Container } from "@mui/material";
import Cliente from "./cliente";
import colores from "../../shared/constants/styles";
import { isAllowed } from "../../shared/utils/permissions";
import { Spinner } from "react-bootstrap";

const Clientes = (props) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(null);
  const [cnpj, setCnpj] = useState(null);

  useEffect(() => {
    if (isAllowed(10)) dispatch(requestClientes());
  }, []);

  const { clientes } = props;

  const handleSearch = () => {
    name || cnpj
      ? props.requestClientesSearch({ name, cnpj })
      : props.requestClientes();
  };

  const handleClean = (event) => {
    event.preventDefault();
    setName("");
    setCnpj("");
    dispatch(requestClientes());
  };

  const handleNameToChange = (event) => {
    setName(event.target.value);
  };

  const handleCNPJToChange = (event) => {
    setCnpj(event.target.value);
  };

  return (
    <div
      style={{
        backgroundColor: colores.grisClaro,
        overflow: "hidden",
        clear: "both",
      }}
    >
      <div>
        <div
          className="container-fluid"
          style={{
            width: "100%",
            overflow: "hidden",
            clear: "both",
            margin: "1.85rem",
          }}
        >
          <div className="d-flex justify-content-center">
            <hr style={{ width: "90%", color: "black", marginTop: "0" }}></hr>
          </div>
          <Container
            maxWidth="w-100"
            style={{ paddingRight: "60px", paddingLeft: "60px" }}
          >
            <div
              className="d-flex justify-content-between flex-wrap align-items-center "
              style={{ marginBottom: "0.600rem", paddingRight: "3.5rem" }}
            >
              <h1 className="fw-bolder" style={{ fontSize: "bolder" }}>
                CLIENTES
              </h1>
            </div>
          </Container>
        </div>
        <div
          className="container-fluid mx-0 px-0 w-100"
          style={{ margin: "2rem" }}
        >
          <div
            className="container-fluid"
            style={{
              backgroundColor: "white",
              width: "100%",
              overflow: "hidden",
              clear: "both",
              marginBottom: "1.85rem",
              paddingLeft: "76px",
              paddingRight: "76px",
            }}
          >
            <div className="d-flex" style={{ margin: "2rem 0" }}>
              <TextField
                id="name"
                value={name}
                name="name"
                onChange={handleNameToChange}
                label="Nombre de cliente"
                variant="outlined"
                style={{ marginRight: "2vh" }}
              />
              <TextField
                id="cnpj"
                value={cnpj}
                name="cnpj"
                onChange={handleCNPJToChange}
                label="CNPJ"
                variant="outlined"
                style={{ marginRight: "4vh" }}
              />
              <div className="d-flex align-items-end">
                <button
                  type="submit"
                  style={{ background: colores.rojo, color: "white" }}
                  class="btn"
                  onClick={handleSearch}
                >
                  Buscar
                </button>
                <button
                  style={{
                    background: colores.white,
                    color: "red",
                    borderColor: "red",
                    marginLeft: "2vh",
                  }}
                  class="btn"
                  onClick={handleClean}
                >
                  Limpiar
                </button>
              </div>
            </div>
            <Grid>
              {!props.loading ? (
                <Grid container spacing={3}>
                  {clientes?.map((cliente) => (
                    <Cliente key={cliente.id} data={cliente} />
                  ))}
                </Grid>
              ) : (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    clientes: state.clientes.clientes,
    loading: state.clientes.loading,
  }),
  (dispatch) => ({
    requestClientesSearch: (search) => dispatch(requestClientesSearch(search)),
    requestClientes: () => dispatch(requestClientes()),
  }),
)(Clientes);
